export default __webpack_public_path__ + "separator.png?904f844cba1dd9e21768c1f84ee0cf57";